<template>
  <footer>
    <div class="inner">
      <div class="appTip">
        {{ $t('home.appNote.desc01', { platform: 'VT Markets' }) }}
        <span class="blue" @click="appVisible = true" data-testid="appDialog"> {{ $t('home.appNote.desc02') }}</span>
      </div>
      <p v-html="$t('footer.riskWarn')"></p>
    </div>
    <App :appVisible.sync="appVisible"></App>
  </footer>
</template>

<script>
import App from '@/components/home/App';

export default {
  name: 'homePage',
  components: {
    App
  },
  data() {
    return {
      appVisible: false
    };
  },
  methods: {
    redirectDemoAcc() {
      this.$router.push('/openDemoAccount');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/layout/footer.scss';
</style>
